module.exports = __webpack_public_path__ + "qualtrics-16x16.svg";